/* Phone helpers (2026-10-04). Loads before tarinii-v4.js so the drawn oval is added to the cart bar button too. */
(function () {
  // cart: total + checkout in a bar fixed at the bottom of the screen
  var form = document.getElementById('cart'), total = document.querySelector('.t-receipt__row--total span:last-child');
  if (form && total && document.querySelector('.t-cart__checkout')) {
    var bar = document.createElement('div');
    bar.className = 't-cartbar';
    bar.innerHTML = '<span class="t-cartbar__total"></span><button type="submit" form="cart" name="checkout" class="t-btn t-btn--fill t-stickybar__add t-cartbar__go">checkout</button>';
    bar.querySelector('.t-cartbar__total').textContent = total.textContent.trim();
    document.body.appendChild(bar);
  }

  document.querySelectorAll('.t-cart__qtyinput').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.form, update = form && form.querySelector('[name="update"]');
      if (!form) return;
      if (update && form.requestSubmit) form.requestSubmit(update); else if (update) update.click(); else form.submit();
    });
  });
})();
